import { DATE_FORMAT } from '@shared/utils'
import dayjs from 'dayjs'

export const formatDate = (
  date?: dayjs.ConfigType,
  formatStr: string = DATE_FORMAT,
  inputFormat?: string
): string => {
  if (!date) return ''

  const d = inputFormat ? dayjs(date, inputFormat) : dayjs(date)
  if (!d.isValid()) return ''

  return d.format(formatStr)
}
